import { gsap } from "gsap"

const initNav = () => {
  const nav = document.querySelector(".nav")
  const toggle = document.querySelector(".nav__toggle")
  const navCollapse = document.querySelector(".nav__collapse")
  const navListItems = document.querySelectorAll(".nav__list-item")
  const openNavBg = document.querySelector(".open-nav-bg")

  const smUpMediaQuery = window.matchMedia("(min-width: 576px)")

  let isBreakpointSmUp = smUpMediaQuery.matches

  smUpMediaQuery.addEventListener(
    "change",
    (event) => (isBreakpointSmUp = event.matches)
  )

  const mdUpMediaQuery = window.matchMedia("(min-width: 768px)")

  let isBreakpointMdUp = mdUpMediaQuery.matches

  mdUpMediaQuery.addEventListener(
    "change",
    (event) => (isBreakpointMdUp = event.matches)
  )

  // otváranie / zatváranie menu
  const closeSmUpNavCollapse = () => {
    gsap.to(navCollapse, {
      duration: 0.4,
      ease: "power2.out",
      width: 0,
      onComplete: () => (navCollapse.style.width = null),
    })
    gsap.to(openNavBg, {
      duration: 0.4,
      opacity: 0,
      onComplete: () => gsap.set(openNavBg, { visibility: "hidden" }),
    })
  }

  toggle.addEventListener("click", () => {
    nav.classList.toggle("nav--open")
    document.body.classList.toggle("overflow-hidden")

    // od sm breakpointu vyššie sa collapse vysúva zo strany
    if (isBreakpointSmUp) {
      if (nav.classList.contains("nav--open")) {
        // otvorí sa collapse
        gsap.to(navCollapse, {
          duration: 0.4,
          ease: "power2.in",
          width: "100%",
        })
        gsap.fromTo(
          navListItems,
          {
            x: 20,
            opacity: 0,
          },
          {
            duration: 0.4,
            delay: 0.1,
            opacity: 1,
            x: 0,
            stagger: 0.07,
            ease: "back.in",
          }
        )
        gsap.set(openNavBg, { visibility: "visible" })
        gsap.to(openNavBg, { duration: 0.4, opacity: 1 })
      } else {
        closeSmUpNavCollapse()
      }
    }
  })

  // zatvorí nav collapse pri kliku na pozadie
  openNavBg.addEventListener("click", () => {
    nav.classList.toggle("nav--open")
    document.body.classList.toggle("overflow-hidden")
    closeSmUpNavCollapse()
  })

  // zmena vzhľadu po prejdení na stránke nižšie
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      nav.classList.remove("nav--below-header")
    } else {
      nav.classList.add("nav--below-header")
    }
  })

  const whitePageMenuTrigger = document.querySelector(
    ".white-page-black-menu-trigger"
  )

  const isHomepage = document.body.classList.contains("homepage")

  if (isHomepage) {
    // na úvodnej stránke sa cez intersection observer kontroluje menu do md breakpointu
    if (!isBreakpointMdUp) {
      observer.observe(whitePageMenuTrigger)
    }
  } else {
    // na stránkach s gradientom sa menu zmení po prejdení gradientu v hlavičke
    const gradient = document.querySelector(".gradient")

    if (gradient !== null) {
      observer.observe(gradient)
    }

    // na stránkach s bielym pozadím po prejdení neviditeľného elementu
    if (whitePageMenuTrigger !== null) {
      observer.observe(whitePageMenuTrigger)
    }
  }
}

export default initNav
